import React from 'react'
import Translation from "../../../../../../components/common/translation/translation.component";
const LineChartToolTip = ({ active, payload, label, invoiceMonth }) => { 

    const hasMatchingDate = invoiceMonth.some(item => {
        return item.InvoiceMonth === payload[0]?.payload?.Month && new Date(payload[0]?.payload?.Date).getFullYear() === item.InvoiceYear
    });
    const totalNetAmount = payload[0]?.payload?.TotalNetAmount;
    const totalGrossAmount = payload[0]?.payload?.TotalGrossAmount;

        if(hasMatchingDate && totalNetAmount !== 0 && totalGrossAmount !== 0){
            return (
                <div className="custom-line-chart-tooltip">
                    <p className="label">{`${label}`}</p>
                    <p className="net-amount">{`Net Amount: ${payload[0]?.payload?.TotalNetAmount}`}</p>
                    <p className="gross-amount">{`Gross Amount: ${payload[0]?.payload?.TotalGrossAmount}`}</p>
                </div>
            );
        }
        else {
            return (
                <div className="custom-line-chart-tooltip">
                    <p className="label"><Translation translationKey={"tooltip_no_invoice"} /></p>
                </div>
            );
           
        }

    };

  export default LineChartToolTip;